import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["current", "pageSize", "total", "onChange", "onPageSizeChange", "autoHide"];
import React, { useContext } from "react";
import { Pagination } from '@alifd/next';
import { PaginationContext } from "../contexts";
import { useCreation } from 'ahooks';
function Paginator(props) {
  var className = props.className;
  var _useContext = useContext(PaginationContext),
    current = _useContext.current,
    _useContext$pageSize = _useContext.pageSize,
    pageSize = _useContext$pageSize === void 0 ? 10 : _useContext$pageSize,
    _useContext$total = _useContext.total,
    total = _useContext$total === void 0 ? 0 : _useContext$total,
    onChange = _useContext.onChange,
    onPageSizeChange = _useContext.onPageSizeChange,
    autoHide = _useContext.autoHide,
    rest = _objectWithoutProperties(_useContext, _excluded);
  var firstPageSize = useCreation(function () {
    return pageSize;
  }, []);
  if (autoHide && total <= firstPageSize) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Pagination, _extends({
    className: className,
    current: current,
    pageSize: pageSize,
    total: total,
    onChange: onChange,
    onPageSizeChange: onPageSizeChange
  }, rest));
}
export default Paginator;